import { Box } from "@mui/material";
import React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import Title from "../../components/title";

const Education = () => {
  return (
    <Box sx={{ mt: 5 }}>
      <Title title="Education" />
      <Box className="secondary-bg rounded-lg mt-5">
        <Timeline position="alternate">
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent className="text-white">
              <h6>Institute of Science Trade and Technology</h6>
              <p>BSc. in CSE</p>
              <small>Passing year- 2022</small>
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent className="text-white">
              <h6>Azimpur Govt. Girls' School and College</h6>
              <small>2005-2016</small>
            </TimelineContent>
          </TimelineItem>
        </Timeline>
      </Box>
    </Box>
  );
};

export default Education;
